import { Controller } from "stimulus"

export default class extends Controller {
  load(event) {
    event.preventDefault()

    const link = event.currentTarget
    const confirmMessage = link.dataset.activityPanelConfirmMessage
    if (confirmMessage && !window.confirm(confirmMessage)) return

    const method = link.dataset.activityPanelMethod || "GET"
    this.fetchPanel(link.href, { method })
  }

  submit(event) {
    event.preventDefault()

    const form = event.currentTarget
    this.fetchPanel(form.action, {
      method: form.method,
      body: new FormData(form)
    })
  }

  fetchPanel(url, options = {}) {
    fetch(url, {
      method: options.method || "GET",
      body: options.body,
      headers: {
        "Accept": "text/html",
        "X-CSRF-Token": this.csrfToken()
      },
      credentials: "same-origin"
    })
      .then((response) => response.text())
      .then((html) => {
        this.element.innerHTML = html
        this.highlight()
        this.scrollToPanel()
        this.initializeEditor()
      })
  }

  highlight() {
    this.element.classList.remove("activity-panel-updated")
    this.element.offsetWidth
    this.element.classList.add("activity-panel-updated")
  }

  scrollToPanel() {
    window.scrollTo({
      top: this.element.getBoundingClientRect().top + window.pageYOffset - 100,
      behavior: "smooth"
    })
  }

  initializeEditor() {
    if (!window.tinyMCE) return

    window.tinyMCE.init({
      mode: "textareas",
      theme: "advanced",
      width: 900,
      content_css: "/stylesheets/editor_content.css"
    })
  }

  csrfToken() {
    const meta = document.querySelector("meta[name='csrf-token']")
    return meta && meta.content
  }
}
